import { CardContent } from '@mui/material';
import { CloudAccountType, type Account } from '@repo/api-gw-sdk';

import CreateGcpAccountPanel from './cloudAccountGcpPanel';

import { PanelWrapper } from '../panels/panelWrapper';

export const UpdateAccountGCPPanel = ({
  account,
  onClose,
}: {
  account: Account;
  onClose: () => void;
}) => {
  return (
    <PanelWrapper rounded header={{ title: 'Update role', onClose }}>
      <CardContent className='mx-[40px] p-0'>
        <CreateGcpAccountPanel
          accountType={
            account.accountType || CloudAccountType.AccountTypeUnspecified
          }
          loading={false}
          onCreated={onClose}
          initialProjectId={account.providerAccountId}
        />
      </CardContent>
    </PanelWrapper>
  );
};
